import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Select from 'react-select';
import './AddressingPopup.css';
import {IoIosCloseCircle} from 'react-icons/io';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import {jwtDecode} from "jwt-decode";
import {FaUserPlus} from "react-icons/fa";
import CaseUserStatus from "../../../enums/CaseUserStatus";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";
import "react-datepicker/dist/react-datepicker.css";

const AddrerssingPopupForHeads = ({
                             roleName,
                             onManagerAdded,
                             caseManagers,
                             caseDataDays,
                             departmentId,
                             deps,
                             internalUsers,
                             groupId,
                             holidays
                         }) => {
    const token = localStorage.getItem('jwtToken');
    const decodedToken = jwtDecode(token);
    const userId = decodedToken.sub;
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedUserIdDepartment, setSelectedUserDepartment] = useState('');
    const [users, setUsers] = useState([]);
    const [userViewers, setUserViewers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [headOfDepartmentWasPicked, setHeadOfDepartmentWasPicked] = useState(false);
    const [dedlineDays, setDedlineDays] = useState(parseInt(caseDataDays) > 0 ? caseDataDays : '');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [alertInfo, setAlertInfo] = useState({show: false, message: '', type: ''});
    const [departments, setDepartments] = useState([]);
    const [selectedUserViewerOptions, setSelectedUserViewerOptions] = useState([]);
    const [selectedViewerDepartment, setSelectedViewerDepartment] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(departmentId);


    const isHoliday = (date) => {
        const formattedDate = formatDate(date);
        return holidays.some(holiday => formatDate(new Date(holiday.date)) === formattedDate);
    };


    const formatDate = (date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    };

    const filterDates = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date > today && !isHoliday(date);
    };


    useEffect(() => {
        if (dedlineDays && !isNaN(dedlineDays)) {
            let computedDate = new Date();
            let daysAdded = 0;

            while (daysAdded < dedlineDays) {
                computedDate.setDate(computedDate.getDate() + 1);
                if (filterDates(computedDate)) {
                    daysAdded++;
                }
            }

        }
    }, [dedlineDays]);


    useEffect(() => {
        const allDepartmentsOption = [{id: null, name: "ყველა დეპარტამენტი"}];
        setDepartments(allDepartmentsOption.concat(deps));
    }, [deps]);

    const handleChangeCheckbox = (userId) => {
        setSelectedUserViewerOptions(prevOptions =>
            prevOptions.map(option => {
                if (option.value === userId) {
                    return {...option, isChecked: !option.isChecked};
                }
                return option;
            })
        );
    };






    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };


    const fetchUserDetails = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`);
            const data = response.data;
            return data.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    useEffect(() => {
        if (roleName === "HEADOFDEPARTMENT") {
            const getUserDetails = async () => {
                const headOfDepartmentInfo = await fetchUserDetails(userId);
                if (headOfDepartmentInfo) {
                    setSelectedDepartment(headOfDepartmentInfo.departmentId);
                }
            };
            void getUserDetails();
        }
    }, [roleName, userId]);




    useEffect(() => {
        const fetchUsers = async () => {
            try {

                const rolePriority = {
                    'HeadOfAgency': 1,
                    'DeputyHeadOfAgency': 2,
                    'HeadOfDepartment': 3,
                    'Expert': 4
                };

                internalUsers.sort((a, b) => {
                    if (rolePriority[a.roleName] !== rolePriority[b.roleName]) {
                        return rolePriority[a.roleName] - rolePriority[b.roleName];
                    } else {
                        return a.firstName.localeCompare(b.firstName);
                    }
                });

                if (roleName === "HEADOFAGENCY") {
                    setUsers(internalUsers);
                    setUserViewers(internalUsers);
                } else if (roleName === "DEPUTYHEADOFAGENCY") {
                    const deputyUsers = internalUsers.filter(user => user.roleName !== "DeputyHeadOfAgency");
                    setUsers(deputyUsers);
                    setUserViewers(deputyUsers);
                } else {
                    const currentUser = internalUsers.find(user => user.id === userId);
                    let departmentUsers = [];
                    let headOfDepartments = [];

                    if (currentUser) {
                        departmentUsers = internalUsers.filter(user => user.departmentId === currentUser.departmentId && user.id !== userId);
                        headOfDepartments = internalUsers.filter(user => user.roleName === "HeadOfDepartment" && user.id !== userId);
                        const filteredUsers = [...departmentUsers, ...headOfDepartments.filter(hod => !departmentUsers.some(du => du.id === hod.id))];
                        setUsers(filteredUsers);
                        setUserViewers(filteredUsers);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        };
        void fetchUsers();
    }, [userId, roleName, token]);

    const formatUserOptions = (users) => {
        return users
            .filter(user => selectedDepartment === null || user.departmentId === selectedDepartment || user.roleName === "DeputyHeadOfAgency")
            .filter(user => !selectedUserViewerOptions.some(viewer => viewer.value === user.id))
            .map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`,
                role: user.roleName.toUpperCase(),
                departmentId: user.departmentId
            }));
    };

    const formatUserViewerOptions = (users) => {
        return users
            .filter(user => user.roleName !== "DeputyHeadOfAgency")
            .filter(user => user.departmentId !== selectedDepartment)
            .filter(user => selectedViewerDepartment === null || user.departmentId === selectedViewerDepartment)
            .filter(user => user.id !== selectedUserId)

            .map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`,
                isChecked: false,
                role: user.roleName.toUpperCase(),
                departmentId: user.departmentId
            }));
    };
    const formatUserViewerOptionsForHeadOfDepartment = (users) => {
        return users
            .filter(user => user.roleName !== "DeputyHeadOfAgency")
            .filter(user => user.departmentId === selectedDepartment)
            .filter(user => selectedViewerDepartment === null || user.departmentId === selectedViewerDepartment)
            .filter(user => user.id !== selectedUserId)

            .map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`,
                isChecked: false,
                role: user.roleName.toUpperCase(),
                departmentId: user.departmentId
            }));
    };

    const handleUserChange = (selectedOption) => {
        setSelectedUserId(selectedOption ? selectedOption.value : '');
        setSelectedUserDepartment(selectedOption ? selectedOption.departmentId : '');
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        if (selectedUserViewerOptions.length === 0 ) {
            return;
        }
        const uncheckedCount = selectedUserViewerOptions.filter(option => !option.isChecked).length;
        if (uncheckedCount === 1) {
            setShowConfirmationModal(true);
        }
        setShowConfirmationModal(true);
    };

    const handleConfirm = async () => {
        setLoading(true);
        let chatUsers = []
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/AddNewCaseUser`;
        const caseId = new URLSearchParams(window.location.search).get('id');


        try {
            const headOfDepartment = users.find(user => user.roleName === "HeadOfDepartment" && user.departmentId === selectedUserIdDepartment) || {id: null};

            let addedHeadOfDepartments = [];
            let addedHeadOfDepartmentsNotifications = [];

            selectedUserViewerOptions.sort((a, b) => (b.isChecked === true) - (a.isChecked === true));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {

                if (headOfDepartment) {
                    if (
                        viewer.role === "EXPERT" &&
                        roleName !== "HEADOFDEPARTMENT" &&
                        !addedHeadOfDepartmentsNotifications.includes(headOfDepartment.id)
                    ) {
                        const caseNotification = {
                            nextStepUserId: headOfDepartment.id,
                            caseId: caseId ? parseInt(caseId, 10) : 0,
                            documentId: null,
                            action: CaseNotificationEnum.added.id,
                            caseStatus: 8,
                            viewed: false,
                            role: viewer.isChecked ? 2 : 3
                        };
                        addedHeadOfDepartmentsNotifications.push(headOfDepartment.id);
                        return axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
                    }
                }
            }));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const headOfDepartment = users.find(
                    user => user.roleName === "HeadOfDepartment" && user.departmentId === viewer.departmentId
                );
                const isHeadOfDepartmentAlreadyPicked = headOfDepartment
                    ? selectedUserViewerOptions.find(user => user.value === headOfDepartment.id)
                    : null;

                if (roleName !== "HEADOFDEPARTMENT") {
                    if (viewer.role === "EXPERT" && roleName !== "HEADOFDEPARTMENT" && !addedHeadOfDepartments.includes(headOfDepartment.id) && !isHeadOfDepartmentAlreadyPicked) {
                        const payloadViewer = {
                            caseId: caseId ? parseInt(caseId, 10) : 0,
                            toUserId: headOfDepartment.id,
                            dedlineDays: null,
                            status: 0,
                            addedBySystem: false,
                            caseUserType: CaseUserStatus.CaseViewer,
                            approver: viewer.isChecked
                        };
                        addedHeadOfDepartments.push(headOfDepartment.id);
                        chatUsers.push(payloadViewer.toUserId)
                        return axios.post(apiUrl, payloadViewer);
                    }
                }
            }));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const payloadViewer = {
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    toUserId: viewer.value,
                    dedlineDays: null,
                    status: 0,
                    addedBySystem: false,
                    caseUserType: CaseUserStatus.CaseViewer,
                    approver: viewer.isChecked
                };

                chatUsers.push(payloadViewer.toUserId)
                return axios.post(apiUrl, payloadViewer);

            }));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const caseNotification = {
                    nextStepUserId: viewer.value,
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    documentId: null,
                    action: CaseNotificationEnum.added.id,
                    caseStatus: 8,
                    viewed: false,
                    role: viewer.isChecked ? 2 : 3

                };
                return axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
            }));


            const caseNotification = {
                nextStepUserId: selectedUserId,
                caseId: caseId ? parseInt(caseId, 10) : 0,
                documentId: null,
                action: CaseNotificationEnum.added.id,
                caseStatus: 8,
                viewed: false
            };

            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);



            setShowPopup(false);
            setSelectedUserId('');
            setAlertInfo({show: true, message: 'მენეჯერი წარმატებით დაემატა!', type: 'success'});
            onManagerAdded();

        } catch (error) {
            setAlertInfo({show: true, message: error.toString(), type: 'error'});
            console.error(error);
        } finally {
            setSelectedViewerDepartment(null)
            setSelectedUserViewerOptions([])
            setLoading(false);
            setShowConfirmationModal(false);
            const chatUsersPayload = {
                chatName: groupId.chatName,
                chatUsersIds: [...groupId.chatUsersIds, ...chatUsers],
                id: groupId.id,
                caseNumber: groupId.caseNumber,
                caseID: groupId.caseID

            };

            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditChatGroup`, chatUsersPayload);
        }
    };

    const userOptions = formatUserOptions(users);
    const userViewerOptions = formatUserViewerOptions(userViewers);
    const userViewerOptionsForHeadOfDepartment = formatUserViewerOptionsForHeadOfDepartment(userViewers);

    const handleChangeUserViewer = (selectedValues) => {
        setSelectedUserViewerOptions(selectedValues);
    };


    useEffect(() => {
        if ((roleName === "HEADOFAGENCY" || roleName === "DEPUTYHEADOFAGENCY") && userOptions.length > 0 && !headOfDepartmentWasPicked) {
            const headOfDepartment = userOptions.find(user => user.role === "HEADOFDEPARTMENT" && user.departmentId === departmentId);
            if (headOfDepartment) {
                setHeadOfDepartmentWasPicked(true)
                handleUserChange(headOfDepartment);
            }
        }
    }, [userOptions, roleName, departmentId]);


    return (
        <div>
            {showPopup && (
                <div className="overlay"></div>
            )}
            <button
                onClick={() => setShowPopup(true)}
                className="document-buttonn"
            >
                <span style={{marginRight: 15}} className="button-label">დამატება</span>
                <div className="button-icon-container">
                    <span style={{fontSize: 20}} className="button-icon"><FaUserPlus/></span>
                </div>
            </button>

            {showPopup && (
                <div style={{height: 700}} className="popup">
                    <form onSubmit={handleSubmit} className="form-container-user-select">
                        <h4>დეპარტამენტი</h4>

                        {roleName !== "HEADOFDEPARTMENT" && (
                            <>
                                <h4>დამატებითი შემსრულებლის დეპარტამენტი</h4>
                                <Select
                                    style={{cursor: "pointer"}}
                                    options={departments
                                        .filter(department => department.id !== selectedDepartment) // Filter out the selected department
                                        .map(department => ({
                                            value: department.id,
                                            label: department.name
                                        }))}
                                    value={departments.find(department => department.id === selectedViewerDepartment) ? {
                                        value: selectedViewerDepartment,
                                        label: departments.find(department => department.id === selectedViewerDepartment)?.name
                                    } : null}
                                    onChange={selectedOption => setSelectedViewerDepartment(selectedOption ? selectedOption.value : null)}
                                    className="search-select-popup"
                                    placeholder="აირჩიეთ დამატებითი შემსრულებლის დეპარტამენტი..."
                                    isClearable
                                    isSearchable
                                    noOptionsMessage={() => "არაფერი მოიძებნა"}
                                />
                            </>
                        )}


                        <h4>დამატებითი შემსრულებლი</h4>
                        {roleName !== "HEADOFDEPARTMENT" ? (
                            <Select
                                style={{cursor: "pointer"}}
                                options={userViewerOptions}
                                className="search-select-popup"
                                placeholder="მოძებნეთ დამატებითი შემსრულებლი..."
                                isClearable
                                isSearchable
                                noOptionsMessage={() => "არაფერი მოიძებნა"}
                                isMulti
                                onChange={handleChangeUserViewer}
                                value={selectedUserViewerOptions}

                            />
                        ) : (
                            <Select
                                style={{cursor: "pointer"}}
                                options={userViewerOptionsForHeadOfDepartment}
                                className="search-select-popup"
                                placeholder="მოძებნეთ დამატებითი შემსრულებლი..."
                                isClearable
                                isSearchable
                                noOptionsMessage={() => "არაფერი მოიძებნა"}
                                isMulti
                                onChange={handleChangeUserViewer}
                                value={selectedUserViewerOptions}

                            />
                        )}


                        <div>
                            {selectedUserViewerOptions.map((option) => (
                                <div className="checkbox-label-container" key={option.value}>
                                    <label>{option.label}</label>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <div style={{paddingRight: 10}}> ვიზატორი:</div>
                                        <input
                                            style={{cursor: "pointer"}}
                                            type="checkbox"
                                            checked={option.isChecked}
                                            onChange={() => handleChangeCheckbox(option.value)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                        {loading ? (
                            <div className="loader"></div>
                        ) : (
                            <button
                                type="submit"
                                style={{fontFamily: "'FiraGO-SemiBold'"}}
                                className="submit-button"
                                disabled={selectedUserViewerOptions.length === 0}
                            >
                                შენახვა
                            </button>

                        )}
                    </form>
                    <IoIosCloseCircle className="upload-single-close-icon"
                                      onClick={() => setShowPopup(false)}
                    />
                </div>
            )}
            <ConfirmationModal
                isOpen={showConfirmationModal}
                onRequestClose={() => setShowConfirmationModal(false)}
                onConfirm={handleConfirm}
            />
            {alertInfo.show && (
                <CustomAlert
                    message={alertInfo.message}
                    type={alertInfo.type}
                    onClose={() => setAlertInfo({show: false, message: '', type: ''})}
                />
            )}
        </div>
    );
};

export default AddrerssingPopupForHeads;
